import EdFormModel from '@/models/ed-form.model';
import EdInputModel from '@/models/ed-input.model';
import { Status } from '@/models/status.model';
import { IOrganizationPreferences } from '@/preferences/interfaces/organization-preferences.interface';
import { Preference } from '@/preferences/models/preference.model';
import { PREFERENCES_KEYS, PREFERENCES_STORE } from '@/preferences/values/preferences.values';
import Vue from 'vue';
import Component from 'vue-class-component';
import { numeric, required } from 'vuelidate/lib/validators';
import KEYS from '@/values/keys';

@Component({})
export default class PreferencesView extends Vue {

  public preferencesForm: any = null;
  public status: Status = new Status();
  public saving: boolean = false;
  public saved: boolean = false;

  get institutionId() {
    let institutions: any[] = this.$store.state.ToolsStore.institutionInfo;
    return institutions.length > 0 ? institutions[0].organizationId : null;
  }

  get organizationPreferences(): Preference[] {
    let preferences = [];
    let org: IOrganizationPreferences = this.$store.state.PreferencesStore
      .organizationPreferences.find(p => p.organizationId == this.institutionId);
    if(org) preferences = org.preferences;
    return preferences;
  }

  get timeframe() {
    let value = '';
    if(this.organizationPreferences) {
      let pref = this.organizationPreferences
        .find(p => p.preferenceName == PREFERENCES_KEYS.TIME_FRAME_CONTENT_VIEW_END);
      if(pref) value = pref.preferenceValue;
    }
    return value;
  }

  get visibilityDisclamer(): string {
    let days = this.$i18n.t('tools.preferences.days');
    let value = '0';
    if(this.preferencesForm) {
      let timeframeValue = this.preferencesForm.timeframe.value;
      value = timeframeValue || value;
    }
    let timeframe = `${value} ${days}`.toLocaleLowerCase();
    let disclamer = this.$i18n.t(
      'tools.preferences.visibilityDisclamer', { timeframe });
    return String(disclamer);
  }

  async setOrganizationPreferences() {
    try {
      this.saving = true;
      let data: IOrganizationPreferences = {
        organizationId: this.institutionId,
        preferences: [{
          preferenceName: PREFERENCES_KEYS.TIME_FRAME_CONTENT_VIEW_END,
          preferenceValue: this.preferencesForm.timeframe.value
        },{
          preferenceName: PREFERENCES_KEYS.TIME_FRAME_CONTENT_VIEW_START,
          preferenceValue: this.preferencesForm.timeframe.value
        }]
      };
      await this.$store.dispatch(
        PREFERENCES_STORE.ACTIONS.SAVE_ORGANIZATION_PREFERENCES, 
        data
      );
      this.saved = true;
      setTimeout(() => {
        this.saved = false;
      }, 2000);
      this.saving = false;
    } catch(err) {
      this.$EdModal.createMessageModal({
        title: this.$i18n.t('errors.ups'),
        body: this.$i18n.t('errors.errorSaving'),
        type: KEYS.EVENT_TYPES.DANGER
      });
      this.saving = false;
    }
  }

  initForm(timeframe: string = '') {
    this.preferencesForm = EdFormModel([
      EdInputModel('timeframe', timeframe, { required, numeric })
    ]);
  }

  async getInstitutionPreferences() {
    try {
      this.status.setLoading();
      await this.$store.dispatch(
        PREFERENCES_STORE.ACTIONS.GET_ORGANIZATION_PREFERENCES, 
        this.institutionId
      );
      this.initForm(this.timeframe);
      this.status.setLoad();
    } catch(err) {
      this.status.setError();
    }
  }

  created() {
    if(this.organizationPreferences.length > 0) {
      this.initForm(this.timeframe);
      this.status.setLoad();
    } else {
      this.getInstitutionPreferences();
    }
  }

}